"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setRaven = setRaven;
exports.setHistory = setHistory;
exports.default = initWordPress;

var _checkIfWordPress = _interopRequireDefault(require("./checkIfWordPress"));

var _getLeadinConfig2 = _interopRequireDefault(require("./getLeadinConfig"));

var _showWarnings = _interopRequireDefault(require("./showWarnings"));

var isWordPress = (0, _checkIfWordPress.default)();

function notifyLocationChange(location) {
  try {
    window.top.postMessage(JSON.stringify({
      leadin_sync_route: location.pathname,
      leadin_sync_search: location.search
    }), '*');
  } catch (e) {//
  }
}

function setRaven(Raven) {
  var _getLeadinConfig = (0, _getLeadinConfig2.default)(),
      leadinPluginVersion = _getLeadinConfig.leadinPluginVersion,
      phpVersion = _getLeadinConfig.phpVersion,
      wpVersion = _getLeadinConfig.wpVersion;

  try {
    if (isWordPress) {
      Raven.setTagsContext({
        v: leadinPluginVersion,
        php: phpVersion,
        wp: wpVersion
      });
    }
  } catch (e) {//
  }
}

function setHistory(history) {
  try {
    if (isWordPress) {
      if (typeof history.listen === 'function') {
        history.listen(function () {
          return notifyLocationChange(window.location);
        });
      } else if (typeof history.on === 'function') {
        history.on('route', function () {
          return notifyLocationChange(window.location);
        });
      }

      notifyLocationChange(window.location);
    }
  } catch (e) {//
  }
}

function initWordPress(Raven, history, DEPRECATED_usageTracker, DEPRECATED_promiseStatus) {
  try {
    if (isWordPress) {
      var hsNav = document.getElementById('hs-nav-v4');

      if (hsNav) {
        hsNav.classList.add('wordpress-plugin-nav');
      } else if (Raven) {
        Raven.captureMessage('[ Wordpress-Plugin ] : could not append class to the HubSpot nav');
      } // Set global


      if (!window.hubspot) {
        window.hubspot = {};
      }

      window.hubspot.wordpress = (0, _getLeadinConfig2.default)();
      var style = document.createElement('style');
      style.type = 'text/css';
      var css = "#hs-nav-v4 { display: none; }\n      .contacts > #hs-nav-v4~.app { height: 100vh !important; }";

      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(document.createTextNode(css));
      }

      document.getElementsByTagName('head')[0].appendChild(style);

      if (Raven) {
        setRaven(Raven);
      }

      if (history) {
        setHistory(history);
      }

      (0, _showWarnings.default)();
    }
  } catch (e) {//
  }

  return DEPRECATED_promiseStatus || Promise.resolve();
}